import Vue from 'vue'
import Vuex from 'vuex';


import { getList } from "@/api/search";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    list: [],
    total: 0,
    diseaseTop10: [],
    listLoading: false
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    setTotal(state, total) {
      state.total = total;
    },
    setDiseaseTop10(state, diseaseTop10) {
      state.diseaseTop10 = diseaseTop10;
    },
    setListLoading(state, isLoading) {
      state.listLoading = isLoading;
    }
  },
  actions: {
    fetchData({ commit }) {
      commit('setListLoading', true);
      getList().then((response) => {
        commit('setList', response.data.data.result1);
        commit('setTotal', response.data.data.result1.length);
        commit('setDiseaseTop10', response.data.data.result2);
        commit('setListLoading', false);
      });
    }
  }
})
